// @flow
import React from 'react';
import classNames from 'classnames';

import './Switch.css';

type Props = {
  checked: boolean,
  onChange: Function,
  style?: Object,
  label?: string
};

class Switch extends React.Component<Props, {}> {
  render() {
    const { checked, onChange, label, style } = this.props;

    return (
      <div
        className={classNames({ checked: checked, unchecked: !checked })}
        name="Switch"
        style={style}
        onClick={(e) => {
          e.stopPropagation();
          onChange({ target: { checked: !checked } });
        }}>
        <div className="wrapper">
          <div className="handle"/>
        </div>
        {label ? <span className="label">{label}</span> : null}
      </div>
    );
  }
}

export default Switch;
